<template>
  <v-chart
    :option="chartOptions"
    style="width: 600px; height: 400px;"
  ></v-chart>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts";

export default {
  components: {
    "v-chart": ECharts
  },
  data() {
    return {
      chartOptions: {
        xAxis: { data: ["A", "B", "C"] },
        yAxis: {},
        series: [
          {
            type: "pictorialBar",
            data: [120, 200, 150],
            symbol: "rect",
            symbolRepeat: true,
            symbolSize: [30, 10],
            symbolMargin: 2
          }
        ]
      }
    };
  }
};
</script>
